var _g, _path, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 454,
    height: 358,
    viewBox: "0 0 454 358",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_411_138)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 1,
    width: 448,
    height: 352,
    rx: 31,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 59H451V321C451 338.121 437.121 352 420 352H34C16.8792 352 3 338.121 3 321V59Z",
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 29,
    r: 9,
    fill: "#FF605C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 29,
    r: 9,
    fill: "#00CA4E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 29,
    r: 9,
    fill: "#FFBD44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 82,
    width: 110,
    height: 12,
    rx: 6,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 102,
    width: 161,
    height: 12,
    rx: 6,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 136,
    width: 246,
    height: 12,
    rx: 6,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 292,
    width: 246,
    height: 12,
    rx: 6,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 84,
    width: 86,
    height: 12,
    rx: 6,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 313,
    width: 149,
    height: 12,
    rx: 6,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 105,
    width: 68,
    height: 12,
    rx: 6,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 157,
    width: 149,
    height: 12,
    rx: 6,
    fill: "#EBEBEB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152 185H407C410.866 185 414 188.134 414 192V270C414 273.866 410.866 277 407 277H152C148.134 277 145 273.866 145 270V192C145 188.134 148.134 185 152 185Z",
    fill: "#F9F9F9",
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 99,
    r: 22,
    fill: "#D9D9D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_411_138",
    x: 0,
    y: 0,
    width: 454,
    height: 358,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_411_138"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_411_138",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentation);
export default __webpack_public_path__ + "static/media/documentation.cf60330a1a3b616f92ebf0fcb74de388.svg";
export { ForwardRef as ReactComponent };